import TransAuth, { AuthComponentRef } from '@/views/components/componentsUI/TransAuth';
import ButtonElement from '@/views/elements/button/ButtonElement';
import { Box, Stack, useTheme } from '@mui/material';
import classNames from 'classnames/bind';
import styles from '../../Unauthorized/ModalRegisterMasterFollower.module.scss';
import { DataOnParents, KeyDataParents } from './ConfigCopy';
import { submitConfigCopyMaster } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import { setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import { useCosInfo, VerifyData } from '@/controllers/gridManager/accountsManager/accountManager';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';
import { useRef, useState } from 'react';
import { validateCode } from '@/utilities';
import ToastUtil from '@/views/components/Toast/Toast';
import useValidateCode from '@/componentShare/hooks/useValidateCode';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents,
    data: any
}

const Step2 = ({ close, back, next, handleSaveDataOnParents, dataOnParents, data }: PropsStep) => {
    const theme = useTheme()
    const { t } = useTranslation()
    const { cosInfo } = useCosInfo()
    const { refaccount } = cosInfo
    const { Step1, dataVerify }: { Step1: any, dataVerify: VerifyData } = dataOnParents
    const { dataMasterTrade } = data

    const refAuth = useRef<AuthComponentRef>(null)
    const [code, setCode] = useState<string>('')

    const handleNext = async () => {
        if (validateCode(code) === false) {
            ToastUtil.error(t('copytrade.common.noEmpty'))
            return
        }

        if (refAuth.current) {
            refAuth.current.processAuth()
        }
    }

    const processUnRegisterFollower = async (dataVerify: any) => {
        setStateLoadingAction(true)

        const body = {
            masterAccount: dataMasterTrade?.afacctno,
            cutLossRate: Step1?.preData?.valueStopLoss?.value,
            takeProfitRate: Step1?.preData?.valueStopProfit?.value,
            buyRange: Step1?.preData?.valueOverBuyPrice?.value,
            sellRange: Step1?.preData?.valueOverSellPrice?.value,
        }

        await submitConfigCopyMaster({ accountId: refaccount, body, dataVerify }).then((rs) => {
            setStateLoadingAction(false)
            if (rs.isSuccess === true) {
                next()
            }
        })
    }


    const handleBack = () => {
        back()
    }

    const isValidCode = useValidateCode(code)

    console.log('ha_check_data', data)

    return (
        <Box>
            <Box
                sx={{ backgroundColor: theme.palette.background.badge, borderRadius: 2 }}
                p={1}
                mb={2}
            >
                <Stack
                    direction={"column"}
                    spacing={1}
                >
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        py={0.5}
                        px={1}
                        borderRadius={1}
                    >
                        <Box>
                            <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                                {t("copytrade.common.masterTrader")}
                            </TypographyElement>
                        </Box>
                        <Box>
                            {dataMasterTrade?.mt_fullname ?? ''}
                        </Box>
                    </Stack>

                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        py={0.5}
                        px={1}
                        borderRadius={1}
                    >
                        <Box>
                            <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                                {t("copytrade.common.bonusFee")}
                            </TypographyElement>
                        </Box>
                        <Box>
                            <ViewNumberFormat displayType='text' isPercentage={true} align='end' value={dataMasterTrade?.bonus_fee ?? 0} />
                        </Box>
                    </Stack>

                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        py={0.5}
                        px={1}
                        borderRadius={1}
                    >
                        <Box>
                            <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                                {t("copytrade.copyMaster.stopCopyWhenProfit")}
                            </TypographyElement>
                        </Box>
                        <Box>
                            <ViewNumberFormat displayType='text' isPercentage={true} align='end' value={Step1?.preData?.valueStopProfit?.value} />
                        </Box>
                    </Stack>

                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        py={0.5}
                        px={1}
                        borderRadius={1}
                    >
                        <Box>
                            <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                                {t("copytrade.copyMaster.stopCopyWhenLoss")}
                            </TypographyElement>
                        </Box>
                        <Box>
                            <ViewNumberFormat displayType='text' isPercentage={true} align='end' value={Step1?.preData?.valueStopLoss?.value} />
                        </Box>
                    </Stack>

                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        py={0.5}
                        px={1}
                        borderRadius={1}
                    >
                        <Box>
                            <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                                {t("copytrade.copyMaster.overBuy")}
                            </TypographyElement>
                        </Box>
                        <Box>
                            <ViewNumberFormat displayType='text' isPercentage={true} align='end' value={Step1?.preData?.valueOverBuyPrice?.value} />
                        </Box>
                    </Stack>

                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        py={0.5}
                        px={1}
                        borderRadius={1}
                    >
                        <Box>
                            <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                                {t("copytrade.copyMaster.overSell")}
                            </TypographyElement>
                        </Box>
                        <Box>
                            <ViewNumberFormat displayType='text' isPercentage={true} align='end' value={Step1?.preData?.valueOverSellPrice?.value} />
                        </Box>
                    </Stack>

                </Stack>

            </Box>

            <Stack
                direction={"column"}
                spacing={2}
            >
                <Box>
                    {dataVerify?.transactionId && <TransAuth
                        ref={refAuth}
                        verified={dataVerify?.verified ?? false}
                        listAuthType={dataVerify?.authtypes ?? []}
                        defaultAuthType={dataVerify?.authtype}
                        transactionId={dataVerify?.transactionId}
                        tokenId={dataVerify?.tokenid}
                        setLoadStatus={setStateLoadingAction}
                        doProcessData={{}}
                        twoFactorAuthFunc={processUnRegisterFollower}
                        noButton={true}
                        onAuthCodeChange={(e: string) => setCode(e)}
                    />}
                </Box>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType="Secondary" className={cx("btn-register")} variant="contained"
                        onClick={() => handleBack()} >{t("copytrade.common.back")}</ButtonElement>
                    <ButtonElement customType="Primary" className={cx("btn-register")} variant="contained"
                        disabled={!isValidCode}
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.confirm")}</ButtonElement>
                </Stack>

            </Stack>
        </Box>
    )
}

export default Step2